import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";
import Cookies from "js-cookie";
// cart product count
export const cartProductCount = createAsyncThunk("client/cart-product-count", async () => {
  // const token = localStorage.getItem("authToken");
  // console.log("data", data);

  try {
    const response = await axios.post(`${baseUrl}vancouverapis/webapp/cart/api/v1/cart-count/${localStorage.getItem("customerId")}`);
    // console.log("cart product count response ", response);
    return response; // ✅ Return only the data
  } catch (error) {
    console.error("Error fetching products:", error);

  }
});

// get cart product

export const getCartProducts = createAsyncThunk("client/get-item-cart", async (data, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");
  const rowid = localStorage.getItem("customerId");
  let guestId = Cookies.get("guest_id");

  try {
    const response = await axios.post(
      `${baseUrl}vancouverapis/webapp/cart/api/v1/get-item-cart/${rowid}`,
      { guestId: guestId },
      {
        headers: {
          "auth-token": token,
        },
      }
    );
    // console.log("get cart products response ", response);
    return response; // ✅ Return only the data
  } catch (error) {
    console.error("Error fetching products:", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data?.message || "error in get cart products");
  }
});
